import React from "react";
import SegmentRecordResultsGraph from "../results-graph";

class SegmentRecordCardioResultsGraph extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  sortSegmentRecordsByDate(segmentRecords) {
    // console.log("%cSorting", "background:orange;");
    const sortedSegmentRecords = segmentRecords.slice().sort((b, a) => {
      if (a.segmentRecord && b.segmentRecord) {
        return (
          new Date(b.segmentRecord.segmentRecordStartTime).getTime() -
          new Date(a.segmentRecord.segmentRecordStartTime).getTime()
        );
      }
      return 0;
    });
    return sortedSegmentRecords;
  }

  getLineDatum(comparisonSegmentRecord, selectedStat) {
    let datum = {
      x: new Date(
        comparisonSegmentRecord.segmentRecord.segmentRecordStartTime
      ).toString(),
    };
    datum["y"] = comparisonSegmentRecord.results[selectedStat];
    return datum;
  }

  getLineData(segmentRecords, selectedStat) {
    return segmentRecords.map((comparisonSegmentRecord) =>
      this.getLineDatum(comparisonSegmentRecord, selectedStat)
    );
  }

  render() {
    const allSegmentRecords = [
      ...this.props.comparisonSegmentRecords,
      {
        id: this.props.baselineSegmentRecord.id,
        segmentRecord: this.props.baselineSegmentRecord,
        results: this.props.baselineResultData,
      },
    ];
    // console.log(allSegmentRecords);
    const cardioSegmentRecords = this.sortSegmentRecordsByDate(
      allSegmentRecords.filter(
        (segmentRecord) => segmentRecord.results.resultTypes.targetedCardio
      )
    );
    const lines = {
      elapsedTargetedCardioTime: {
        data: this.getLineData(
          cardioSegmentRecords,
          "elapsedTargetedCardioTime"
        ),
        color: "#796FF3",
        duration: 2000,
        label: "Elapsed Cardio Time",
      },
      jumps: {
        data: this.getLineData(cardioSegmentRecords, "jumps"),
        color: "#F3BE6F",
        duration: 1000,
        label: "Jumps",
      },
      // 'jumpPercentage': {
      //   data: this.getLineData(cardioSegmentRecords, 'jumpPercentage'),
      //   color: 'red',
      //   duration: 3000
      // },
      // 'minHR': {
      //   data: this.getLineData(cardioSegmentRecords, 'minHR'),
      //   color: 'green',
      //   duration: 4000
      // },
      averageCardioHR: {
        data: this.getLineData(cardioSegmentRecords, "averageCardioHR"),
        color: "#d2232a",
        duration: 4000,
        label: "Average Heart Rate",
      },
      // 'maxHR': {
      //   data: this.getLineData(cardioSegmentRecords, 'maxHR'),
      //   color: 'darkgreen',
      //   duration: 4000
      // },
      calories: {
        data: this.getLineData(cardioSegmentRecords, "calories"),
        color: "#6FF384",
        duration: 4000,
        label: "Calories",
      },
    };
    const xAxis = cardioSegmentRecords.map((comparisonSegmentRecord) => {
      return {
        id: comparisonSegmentRecord.segmentRecord.id,
        date: new Date(
          comparisonSegmentRecord.segmentRecord.segmentRecordStartTime
        ).toString(),
      };
    });
    return (
      <SegmentRecordResultsGraph
        lines={lines}
        chartLabel="Cardio Results"
        linkPage="segment-record"
        xAxis={xAxis}
        history={this.props.history}
        baselineSegmentRecord={this.props.baselineSegmentRecord}
        baselineResultData={this.props.baselineResultData}
        multipleAthletes={this.props.multipleAthletes}
        comparisonSegmentRecords={this.props.comparisonSegmentRecords}
      />
    );
  }
}

export default SegmentRecordCardioResultsGraph;
